/* Vyrexwear snelzoeken: live resultaten via Shopify predictive search. */
(function () {
  'use strict';
  var dlg = document.querySelector('[data-search]');
  if (!dlg || !dlg.showModal) return;
  var input = dlg.querySelector('input[name="q"]');
  var start = dlg.querySelector('[data-search-start]');
  var out = dlg.querySelector('[data-search-results]');
  var suggestUrl = dlg.getAttribute('data-suggest-url') || '/search/suggest';
  var searchUrl = dlg.getAttribute('data-search-url') || '/search';
  var timer, ctrl, locked = false;

  /* Teksten komen uit de thema-editor (Koptekst > Zoekvenster) */
  function attr(name) { var v = dlg.getAttribute('data-t-' + name); return v == null ? null : v; }
  var T = {
    tools: attr('tools'),
    products: attr('products'),
    pages: attr('pages'),
    soon: attr('soon'),
    empty: attr('empty') || 'Niets gevonden voor “[zoekterm]”. Probeer “gymshorts” of “lyocell”.',
    all: attr('all') || 'Alle resultaten voor “[zoekterm]”'
  };
  if (T.tools === null) T.tools = 'Tools & uitleg';
  if (T.products === null) T.products = 'Producten';
  if (T.pages === null) T.pages = "Pagina's";
  if (T.soon === null) T.soon = 'Binnenkort';

  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s == null ? '' : String(s);
    return d.innerHTML;
  }
  function fill(tpl, q) { return esc(tpl).split('[zoekterm]').join(esc(q)); }
  function label(text) { return text ? '<p class="vx-search__label">' + esc(text) + '</p>' : ''; }
  function money(p) {
    var cents = Math.round(parseFloat(p) * 100);
    return typeof window.vxFormatMoney === 'function' ? window.vxFormatMoney(cents) : '€' + (cents / 100).toFixed(2).replace('.', ',');
  }
  function img(url) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=160';
  }
  var arrow = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 12h15M13 6l6 6-6 6"/></svg>';

  function open() {
    if (dlg.open) return;
    dlg.showModal();
    if (window.vxScrollLock) { window.vxScrollLock.lock(); locked = true; }
    setTimeout(function () { input.focus(); }, 30);
  }
  function close() { if (dlg.open) dlg.close(); }

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-search-open]');
    if (!t) return;
    e.preventDefault();
    open();
  });
  document.addEventListener('keydown', function (e) {
    var tag = (document.activeElement && document.activeElement.tagName) || '';
    if (e.key === '/' && !dlg.open && !/INPUT|TEXTAREA|SELECT/.test(tag)) { e.preventDefault(); open(); }
  });
  dlg.querySelector('[data-search-close]').addEventListener('click', close);
  dlg.addEventListener('click', function (e) {
    if (e.target === dlg) { close(); return; }
    /* Een link in het zoekvenster: venster sluiten zodat je direct bij het doel bent (ook bij #usps op de homepage) */
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a) return;
    var url = null;
    try { url = new URL(a.href, window.location.href); } catch (err) {}
    if (url && url.hash && url.origin === window.location.origin && url.pathname === window.location.pathname && window.vxGoToHash) {
      /* Doel staat op deze pagina: eerst venster sluiten (pagina weer scrollbaar), dan erheen */
      e.preventDefault();
      close();
      setTimeout(function () { window.vxGoToHash(url.hash); }, 60);
      return;
    }
    close();
  });
  dlg.addEventListener('close', function () {
    if (locked && window.vxScrollLock) window.vxScrollLock.unlock();
    locked = false;
  });

  /* Onze eigen tools (maatadviseur, lyocell-uitleg, ...) zoeken op trefwoord */
  var tools = Array.prototype.slice.call(dlg.querySelectorAll('.vx-search__tool[data-k]'));
  function norm(s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); }
  function matchTools(q) {
    var words = norm(q).split(/\s+/).filter(function (w) { return w.length >= 2; });
    if (!words.length) return [];
    return tools.filter(function (a) {
      var hay = norm(a.getAttribute('data-k') + ' ' + a.textContent).split(/[\s?.,]+/);
      return words.every(function (w) {
        return hay.some(function (h) { return h.indexOf(w) === 0 || (w.length >= 4 && h.indexOf(w) > -1); });
      });
    });
  }

  function render(q, data) {
    var r = (data && data.resources && data.resources.results) || {};
    var products = r.products || [], pages = r.pages || [], cols = r.collections || [];
    var found = matchTools(q);
    var html = '';
    if (found.length) {
      html += label(T.tools) + '<ul class="vx-search__tools" role="list">';
      found.forEach(function (a) { html += '<li>' + a.outerHTML + '</li>'; });
      html += '</ul>';
    }
    if (products.length) {
      html += label(T.products) + '<ul class="vx-search__products" role="list">';
      products.forEach(function (p) {
        var price = p.available === false ? (T.soon ? '<span class="vx-search__soon">' + esc(T.soon) + '</span>' : '') : (p.price ? money(p.price) : '');
        html += '<li><a class="vx-search__product" href="' + esc(p.url) + '">' +
          '<span class="vx-search__thumb">' + (p.image ? '<img src="' + esc(img(p.image)) + '" alt="" width="64" height="64" loading="lazy">' : '') + '</span>' +
          '<span class="vx-search__ptext"><span class="vx-search__ptitle">' + esc(p.title) + '</span><span class="vx-search__pprice">' + price + '</span></span>' +
          arrow + '</a></li>';
      });
      html += '</ul>';
    }
    var links = cols.concat(pages);
    if (links.length) {
      html += label(T.pages) + '<ul class="vx-search__links" role="list">';
      links.forEach(function (l) { html += '<li><a href="' + esc(l.url) + '">' + esc(l.title) + ' ' + arrow + '</a></li>'; });
      html += '</ul>';
    }
    if (!products.length && !links.length && !found.length) {
      html += '<p class="vx-search__empty">' + fill(T.empty, q) + '</p>';
    }
    html += '<a class="vx-search__all" href="' + searchUrl + '?q=' + encodeURIComponent(q) + '">' + fill(T.all, q) + ' ' + arrow + '</a>';
    out.innerHTML = html;
    out.hidden = false;
    start.hidden = true;
  }

  function run() {
    var q = input.value.trim();
    if (q.length < 2) { out.hidden = true; out.innerHTML = ''; start.hidden = false; return; }
    if (ctrl && ctrl.abort) ctrl.abort();
    ctrl = window.AbortController ? new AbortController() : null;
    var url = suggestUrl + '.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product,page,collection&resources[limit]=5&resources[options][unavailable_products]=last';
    dlg.classList.add('is-loading');
    if (matchTools(q).length) render(q, null);
    fetch(url, { headers: { Accept: 'application/json' }, signal: ctrl ? ctrl.signal : undefined })
      .then(function (r) { return r.json(); })
      .then(function (d) { if (input.value.trim() === q) render(q, d); })
      .catch(function (err) { if (!err || err.name !== 'AbortError') render(q, null); })
      .then(function () { dlg.classList.remove('is-loading'); });
  }
  input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(run, 180); });
})();
